/* eslint-disable */
export default function repHomeReducer(state = {
  tiles_fetched: false,
  tiles_fetching: false,
  home_tiles: [],
  fetching: false,
  fetched: false,
  carousels_fetched: false,
  carousels_fetching: false,
  home_carousels: [],
  carousel_speed: 5
}, action) {
  switch (action.type) {
    case 'GET_REP_HOMEPAGE_TILES_PENDING': {
      return {
        ...state,
        fetching: true,
        fetch: false,
        tiles_fetched: false,
        tiles_fetching: true,
      };
    }
    case 'GET_REP_HOMEPAGE_CAROUSELS_PENDING': {
      return {
        ...state,
        fetching: true,
        fetch: false,
        carousels_fetched: false,
        carousels_fetching: true,
      };
    }
    case 'GET_REP_HOMEPAGE_CAROUSELS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        home_carousels: action.payLoad.data,
        permissions: (action.payLoad.data.length > 0 && action.payLoad.data[0].hasOwnProperty('attributes'))
          ? action.payLoad.data[0].attributes.permissions :
          [],
        carousels_fetched: true,
        carousels_fetching: false,
      };
    }
    case 'GET_REP_HOMEPAGE_TILES_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        home_tiles: action.payLoad.data,
        tiles_fetched: true,
        tiles_fetching: false,
      };
    }
    case 'SET_REP_CAROUSEL_SPEED': {
      return {
        ...state,
        carousel_speed: action.payLoad
      };
    }
    default:
      return {...state};
  }
}
